import {
  Button,
  Modal,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import {
  FilePptOutlined,
} from "@ant-design/icons";

import { CustomUpload } from "@/hocComponents";

const PDFModal = forwardRef((props, ref) => {
  const { record } = props;
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    setModalOpen: (flag) => setModalOpen(flag),
  }));
  
  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
          <FilePptOutlined style={{ marginRight: "8px" }} />
          VIEW INVOICE
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalOpen}
      onCancel={() => setModalOpen(false)}
      footer={null}
      maskClosable={false}
      destroyOnClose={true}
      width="80%"
    >
      <div
        key={record?.vendorPaymentId}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <CustomUpload
          setFilePaths={setFilePaths} 
          filePaths={filePaths} 
          setBtnDisabled={setBtnDisabled}
          btnDisabled={btnDisabled}
          isEdit={true}
          vendorPaymentId={record?.vendorPaymentId || undefined}
          foreignId={record?.vendorPaymentId || undefined}
          preCalFile={record?.preCalFile || undefined}
          type={record?.type || 'util_payment'}
          customConfig={{
            pdfHeight: '62vh',
            noShowUpload: true,
            noSubmitBtn: true,
            pageName: record?.pageName || 'ApprovalSummary'
          }}
        />
        <div style={{textAlign: 'center', marginTop: 20}}>
          <Button onClick={() => setModalOpen(false)}>
            cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
});
export default PDFModal;
